import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericMessage } from '@app/interfaces/generic-message';
import { MessageType } from '@app/types/Types';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent {

  genericMessage: GenericMessage;
  safeMessageText: SafeHtml;

  constructor(
    private dialogRef: MatDialogRef<YesNoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _message: GenericMessage,
     private sanitizer: DomSanitizer
  ) {
    this.genericMessage = this._message as GenericMessage;
    this.safeMessageText = this.sanitizer.bypassSecurityTrustHtml(this.genericMessage.messageText);

  }


  submit() {
    this.dialogRef.close(true)
  }

  cancel() {
    this.dialogRef.close(false)
  }
}
